import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PROFILE from "../assits/Profile.avif";
import axios from "axios";
import { BASE_URL, UserContext } from "../contexts/UserContext";
import ButtonLoader from "../components/ButtonLoader";

const Register = () => {
  const [profile, setProfile] = useState();
  const [profile2, setProfile2] = useState();
  const [avatarPreview, setAvatarPreview] = useState(PROFILE);
  const [userData, setUserData] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    password2: "",
    age: "",
  });
  const [gender, setGender] = useState();
  const [loading, setLoading] = useState(false);
  const { error, setError, setMessage, setCurrentUser, setIsAuthenticated } =
    useContext(UserContext);
  const navigate = useNavigate();

  const updateProfileDataChange = (e) => {
    setProfile2(e.target.files[0])
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setProfile(reader.result);
        setAvatarPreview(profile || reader.result);
      }
    };

    reader.readAsDataURL(e.target.files[0]);
  };
  const changeInputHandler = (e) => {
    setUserData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      setLoading(true);


      const myForm = new FormData();
      myForm.append("name", userData.name);
      myForm.append("username", userData.username);
      myForm.append("email", userData.email);
      myForm.append("password", userData.password);
      myForm.append("conformPassword", userData.password2);
      myForm.append("photo", profile2);
      myForm.append("gender", gender);
      myForm.append("age", userData.age);

      const { data } = await axios.post(
        `${BASE_URL}/users/register`,
        myForm,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        }
      );
      setCurrentUser(data?.user);
      setMessage(data?.message);
      setError(null);
      setIsAuthenticated(true);
      navigate("/");
    } catch (error) {
      setError(error?.response?.data.message);
      setMessage(null);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="register">
      <div className="container">
        <h2>Sign Up</h2>
        <form
          onSubmit={handleSubmit}
          className="form register__form"
          encType="multipart/form-data"
        >
          {error && <p className="form__error-message">{error}</p>}
          <input
            type="text"
            placeholder="Full name"
            name="name"
            value={userData.name}
            onChange={changeInputHandler}
          />
          <input
            type="text"
            placeholder="Username"
            name="username"
            value={userData.username}
            onChange={changeInputHandler}
          />
          <input
            type="text"
            placeholder="Email"
            name="email"
            value={userData.email}
            onChange={changeInputHandler}
          />
          <input
            type="password"
            placeholder="Password"
            name="password"
            value={userData.password}
            onChange={changeInputHandler}
          />
          <input
            type="password"
            placeholder="Confirm Password"
            name="password2"
            value={userData.password2}
            onChange={changeInputHandler}
          />
          <input
            type="number"
            placeholder="Enter your age"
            name="age"
            value={userData.age}
            onChange={changeInputHandler}
          />
          <select
            name="gender"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
          >
            <option name="male" key={"male"}>male</option>
            <option name="female" key={"female"}>female</option>
          </select>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: "4rem", height: "4rem", borderRadius: "50%" }}>
              <img
                style={{ borderRadius: "50%" }}
                src={avatarPreview}
                alt="Avatar Preview"
              />
            </div>
            <input
              type="file"
              name="profile"
              accept="image/*"
              onChange={updateProfileDataChange}
            />
          </div>
          <button type="submit" className="btn primary">
            {
              loading ? <ButtonLoader /> : 'Register'
            }
          </button>
        </form>
        <small>
          Already have a account? <Link to={"/login"}>Sign in</Link>
        </small>
      </div>
    </section>
  );
};

export default Register;
